module.exports = __webpack_public_path__ + "img/34_29.d7075402.png";